import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { LoginService } from '../../services/login.service';
import { User, UserRole } from '../../models/user';
import { CommonModule } from '@angular/common';
import { JwtService } from '../../services/jwt.service';

declare var google: any;

@Component({
  selector: 'app-static-pages',
  imports: [RouterModule, CommonModule],
  templateUrl: './static-pages.component.html',
  styleUrl: './static-pages.component.css'
})
export class StaticPagesComponent implements OnInit, AfterViewInit {

  userName = '';

  constructor(private loginService: LoginService, private router: Router, private route: ActivatedRoute, private jwtService: JwtService) {}
  ngAfterViewInit(): void {
    const video = document.querySelector('.home-video') as HTMLVideoElement;
    const phone_video = document.querySelector('.phone-video') as HTMLVideoElement;
    if (video) {
      video.muted = true; // Ensure video is muted for autoplay
      const tryPlay = () => {
        video.play().catch((err) => {
          console.warn('Autoplay failed:', err);
        });
      };

      // Slight delay to ensure styles/layout are complete
      setTimeout(tryPlay, 50);
    }

    if (phone_video) {
      phone_video.muted = true; // Ensure video is muted for autoplay
      const tryPlay = () => {
        phone_video.play().catch((err) => {
          console.warn('Autoplay failed:', err);
        });
      };

      // Slight delay to ensure styles/layout are complete
      setTimeout(tryPlay, 50);
    }

    this.initializeGoogleSignIn();
  }

  ngOnInit(): void {
    const token = localStorage.getItem("jwt");

    if (token) {
      if (this.jwtService.isTokenExpired(token)) {
        this.userName = '';
      } else {
        var decodedToken = this.jwtService.decodeToken(token);
        this.userName = decodedToken.given_name;

        // Already signed in — send them straight to their dashboard, unless they
        // deliberately came back here via "Exit" (?stay=1), in which case let
        // them view the home page.
        const stay = this.route.snapshot.queryParamMap.has('stay');
        if (!stay) {
          const role = Number(decodedToken.role);
          if (role === UserRole.Research) {
            this.router.navigate(['research']);
          } else {
            this.router.navigate(['agent']);
          }
        }
      }

    } else {
      this.userName = '';
    }
  }

  private initializeGoogleSignIn(): void {
    if (typeof google === 'undefined' || !google?.accounts?.id) {
      console.warn('Google Identity Services not available yet.');
      return;
    }

    google.accounts.id.initialize({
      client_id: "1044909932385-53ur8q9fktmmfpidf6b9lltsegodn3f9.apps.googleusercontent.com",
      callback: (response: any) => this.handleGoogleSignIn(response),
      auto_select: false
    });

    const buttonDiv = document.getElementById('staticLoginButtonDiv');
    if (buttonDiv) {
      google.accounts.id.renderButton(buttonDiv, { theme: 'outline', size: 'large' });
    }
  }

  logoutClick(event: MouseEvent) {
    event.preventDefault();
    localStorage.removeItem("jwt");
    this.userName = '';
    setTimeout(() => this.initializeGoogleSignIn(), 0);
  }

  handleGoogleSignIn(response: any) {
      //this.showLoginSpinner = true;

      this.loginService.login(response.credential).subscribe({
        next: (user: User) => {
          // Successful login.
          // Login Service stores the logged in user.
          //this.loggedIn = true;
          //this.pictureUrl = this.loginService.user.picture;
          // this.showLoginSpinner = false;
          this.userName = user.firstName;

          if (user.role === UserRole.Admin || user.role === UserRole.Agent || user.role === UserRole.Scouting || user.role === UserRole.Casting) {
            this.router.navigate(['agent']);
            return;
          } else if (user.role === UserRole.Creator) {
            this.router.navigate(['agent']);
            return;
          } else if (user.role === UserRole.Research) {
            this.router.navigate(['research']);
            return;
          }
        },
        error: (err: any) => {
          console.log(err);
          //this.showLoginSpinner = false;
        }
      });

    }
}
